import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

function initCriteriaSlider() {

    let swiper1 = new Swiper(".criteria-items", {
        autoplay: {
            delay: 4000,
            disableOnInteraction: false
        },
        speed: 1000,
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 50,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            disableOnInteraction: false
        }
    });
}

export function initCriteriaSection() {
    initCriteriaSlider();
}